export default {
    app_id: "QCFDBV3S4S",
    api_key: "872d5c31e3a88c28ce9c42a6fe884b29",
    search_key: "05121ed12fb435a939ba0c487586c4fc",
    index_name: "submittedSurvey"
}